var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('SamplesChart')],1),_c('div',{staticClass:"col-4"},[_c('Calendar',{attrs:{"numpickers":"1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }